<!-- eslint-disable max-len -->
<template>
  <div>
    <div
      :class="{
        'opacity-0 pointer-events-none': !showFilters,
        'modal-active': showFilters,
      }"
      class="
        modal
        fixed
        w-full
        h-full
        top-0
        left-0
        flex
        items-end
        justify-center
        overflow-y-auto
        filter_model_block
      "
    >
      <div
        class="modal-overlay absolute w-full h-full bg-gray-900 opacity-50"
        @click="closeModal"
      ></div>
      <div class="modal-container bg-white w-full shadow-lg z-50 rounded-t-xl">
        <div class="modal-content py-4 text-left px-4">
          <div class="flex justify-between items-center pb-3 Header_block mb-7">
            <div class="w-1/4 cancel_block" @click="closeModal">
              <svg
                class="modal-close w17-17 h17-17"
                style=""
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.7433 0.489467C16.5452 0.494145 16.357 0.576998 16.2198 0.719936L9.00012 7.93966L1.78039 0.719936C1.71048 0.647943 1.62684 0.59071 1.53441 0.551626C1.44198 0.512541 1.34265 0.492401 1.2423 0.492397C1.09304 0.492433 0.947187 0.537001 0.823398 0.620397C0.699609 0.703794 0.603515 0.822226 0.547413 0.960543C0.49131 1.09886 0.47775 1.25077 0.508468 1.39683C0.539185 1.5429 0.612782 1.67648 0.719843 1.78048L7.93957 9.00021L0.719843 16.2199C0.647865 16.289 0.590399 16.3718 0.550812 16.4634C0.511224 16.555 0.490311 16.6536 0.489297 16.7534C0.488282 16.8531 0.507187 16.9521 0.544904 17.0445C0.58262 17.1369 0.638391 17.2208 0.70895 17.2914C0.779508 17.3619 0.863436 17.4177 0.955818 17.4554C1.0482 17.4931 1.14718 17.512 1.24696 17.511C1.34674 17.51 1.44531 17.4891 1.53691 17.4495C1.6285 17.4099 1.71128 17.3525 1.78039 17.2805L9.00012 10.0608L16.2198 17.2805C16.2889 17.3525 16.3717 17.4099 16.4633 17.4495C16.5549 17.4891 16.6535 17.51 16.7533 17.511C16.8531 17.512 16.952 17.4931 17.0444 17.4554C17.1368 17.4177 17.2207 17.3619 17.2913 17.2914C17.3618 17.2208 17.4176 17.1369 17.4553 17.0445C17.493 16.9521 17.5119 16.8531 17.5109 16.7534C17.5099 16.6536 17.489 16.555 17.4494 16.4634C17.4098 16.3718 17.3524 16.289 17.2804 16.2199L10.0607 9.00021L17.2804 1.78048C17.3895 1.6758 17.4643 1.54061 17.4952 1.39263C17.5261 1.24465 17.5116 1.09079 17.4535 0.951215C17.3955 0.811641 17.2966 0.69287 17.1698 0.610472C17.0431 0.528075 16.8944 0.485897 16.7433 0.489467Z"
                  fill="#676666"
                />
              </svg>
            </div>
            <p
              class="
                w-2/4
                font-bold
                title_block
                block
                relative
                text-darkgray
                font-bold
                text-xss text-center
              "
            >
              {{ $t("pages.filters.title") }}
            </p>
            <div v-if="loggedIn" class="w-1/4 wish_block">
              <!-- <svg
                v-if="!favorite"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                @click="favorite = true"
              >
                <path
                  d="M10.0047 0.500015C9.8645 0.499139 9.72689 0.53756 9.60744 0.610919C9.488 0.684278 9.3915 0.789639 9.32889 0.915054L6.75272 6.0674L0.635532 7.0088C0.498607 7.02996 0.370218 7.08863 0.264603 7.1783C0.158987 7.26798 0.0802726 7.38515 0.0371882 7.51683C-0.00589614 7.64851 -0.0116666 7.78955 0.0205166 7.92431C0.0526998 8.05907 0.121579 8.18229 0.219516 8.28029L4.45096 12.5117L3.50858 18.6358C3.4875 18.7728 3.5048 18.9129 3.55856 19.0407C3.61232 19.1685 3.70043 19.2789 3.81313 19.3596C3.92582 19.4403 4.05868 19.4882 4.19696 19.498C4.33524 19.5078 4.47353 19.4791 4.59647 19.4151L9.99979 16.5957L15.4031 19.4151C15.5261 19.4791 15.6643 19.5078 15.8026 19.498C15.9409 19.4882 16.0738 19.4403 16.1865 19.3596C16.2991 19.2789 16.3873 19.1685 16.441 19.0407C16.4948 18.9129 16.5121 18.7728 16.491 18.6358L15.5486 12.5117L19.7801 8.28029C19.878 8.18229 19.9469 8.05907 19.9791 7.92431C20.0112 7.78955 20.0055 7.64851 19.9624 7.51683C19.9193 7.38515 19.8406 7.26798 19.735 7.1783C19.6294 7.08863 19.501 7.02996 19.364 7.0088L13.2469 6.0674L10.6707 0.915054C10.6088 0.791123 10.5138 0.686744 10.3963 0.613486C10.2787 0.540229 10.1432 0.500954 10.0047 0.500015ZM9.99979 2.92677L12.0789 7.08498C12.1324 7.19225 12.2109 7.28512 12.3078 7.35581C12.4046 7.42649 12.517 7.47293 12.6355 7.49123L17.6726 8.26662L14.2195 11.7197C14.1362 11.8031 14.0737 11.9048 14.037 12.0168C14.0004 12.1288 13.9906 12.2478 14.0086 12.3643L14.783 17.3994L10.3465 15.085C10.2394 15.0292 10.1205 15.0001 9.99979 15.0001C9.87908 15.0001 9.76015 15.0292 9.65311 15.085L5.21659 17.3994L5.991 12.3643C6.00893 12.2478 5.99918 12.1288 5.96253 12.0168C5.92589 11.9048 5.86337 11.8031 5.78006 11.7197L2.32694 8.26662L7.36405 7.49123C7.48255 7.47293 7.59493 7.42649 7.69178 7.35581C7.78863 7.28512 7.86713 7.19225 7.92069 7.08498L9.99979 2.92677Z"
                  fill="#676666"
                />
              </svg> -->

              <svg
                v-if="favorite"
                width="20"
                height="20"
                class="h-5 w-1375"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                @click="favorite = false"
              >
                <path
                  d="M10.0047 0.500015C9.8645 0.499139 9.72689 0.53756 9.60744 0.610919C9.488 0.684278 9.3915 0.789639 9.32889 0.915054L6.75272 6.0674L0.635532 7.0088C0.498607 7.02996 0.370218 7.08863 0.264603 7.1783C0.158987 7.26798 0.0802726 7.38515 0.0371882 7.51683C-0.00589614 7.64851 -0.0116666 7.78955 0.0205166 7.92431C0.0526998 8.05907 0.121579 8.18229 0.219516 8.28029L4.45096 12.5117L3.50858 18.6358C3.4875 18.7728 3.5048 18.9129 3.55856 19.0407C3.61232 19.1685 3.70043 19.2789 3.81313 19.3596C3.92582 19.4403 4.05868 19.4882 4.19696 19.498C4.33524 19.5078 4.47353 19.4791 4.59647 19.4151L9.99979 16.5957L15.4031 19.4151C15.5261 19.4791 15.6643 19.5078 15.8026 19.498C15.9409 19.4882 16.0738 19.4403 16.1865 19.3596C16.2991 19.2789 16.3873 19.1685 16.441 19.0407C16.4948 18.9129 16.5121 18.7728 16.491 18.6358L15.5486 12.5117L19.7801 8.28029C19.878 8.18229 19.9469 8.05907 19.9791 7.92431C20.0112 7.78955 20.0055 7.64851 19.9624 7.51683C19.9193 7.38515 19.8406 7.26798 19.735 7.1783C19.6294 7.08863 19.501 7.02996 19.364 7.0088L13.2469 6.0674L10.6707 0.915054C10.6088 0.791123 10.5138 0.686744 10.3963 0.613486C10.2787 0.540229 10.1432 0.500954 10.0047 0.500015Z"
                  fill="#63B15B"
                />
              </svg>

              <p class="refresh_block">
                <svg
                  width="24"
                  class="h-5 w-1375"
                  height="18"
                  viewBox="0 0 24 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  @click="defaultFilters()"
                >
                  <path
                    d="M12.2498 0C7.58472 0 3.7339 3.57738 3.29378 8.12988L2.70687 7.54297C2.61356 7.44706 2.50196 7.37084 2.37867 7.31884C2.25538 7.26684 2.12291 7.24011 1.9891 7.24023C1.79025 7.24048 1.59598 7.3 1.43112 7.41119C1.26626 7.52238 1.13829 7.68018 1.06356 7.86446C0.988822 8.04873 0.970714 8.25109 1.01155 8.44571C1.05238 8.64032 1.15031 8.81834 1.29281 8.95703L3.54281 11.207C3.73035 11.3945 3.98467 11.4998 4.24984 11.4998C4.51501 11.4998 4.76933 11.3945 4.95687 11.207L7.20687 8.95703C7.30284 8.86489 7.37947 8.75452 7.43225 8.63239C7.48504 8.51026 7.51293 8.37883 7.51428 8.24578C7.51563 8.11274 7.49043 7.98077 7.44014 7.85759C7.38985 7.73441 7.31549 7.62251 7.22141 7.52843C7.12733 7.43435 7.01542 7.35999 6.89225 7.3097C6.76907 7.25941 6.63709 7.2342 6.50405 7.23556C6.37101 7.23691 6.23958 7.2648 6.11745 7.31758C5.99532 7.37037 5.88495 7.44699 5.79281 7.54297L5.32699 8.00879C5.80677 4.60476 8.70926 2 12.2498 2C14.4713 2 16.4345 3.03046 17.7186 4.63965C17.7988 4.74709 17.8997 4.83731 18.0155 4.90495C18.1312 4.97259 18.2594 5.01627 18.3924 5.03338C18.5254 5.0505 18.6604 5.04071 18.7895 5.00459C18.9186 4.96847 19.0392 4.90676 19.1439 4.82313C19.2487 4.7395 19.3356 4.63565 19.3995 4.51777C19.4633 4.39988 19.5028 4.27037 19.5156 4.13691C19.5284 4.00346 19.5142 3.86879 19.4739 3.74093C19.4337 3.61306 19.3681 3.49459 19.2811 3.39258C17.6342 1.32876 15.0924 0 12.2498 0ZM19.7352 6.53027C19.4751 6.53416 19.2267 6.63925 19.0428 6.82324L16.7928 9.07324C16.6968 9.16539 16.6202 9.27576 16.5674 9.39788C16.5146 9.52001 16.4868 9.65145 16.4854 9.78449C16.484 9.91753 16.5093 10.0495 16.5595 10.1727C16.6098 10.2959 16.6842 10.4078 16.7783 10.5018C16.8724 10.5959 16.9843 10.6703 17.1074 10.7206C17.2306 10.7709 17.3626 10.7961 17.4956 10.7947C17.6287 10.7934 17.7601 10.7655 17.8822 10.7127C18.0044 10.6599 18.1147 10.5833 18.2069 10.4873L18.6668 10.0273C18.1715 13.4135 15.2778 16 11.7498 16C9.5351 16 7.57678 14.9747 6.29281 13.374C6.21061 13.2715 6.10903 13.1862 5.99387 13.123C5.8787 13.0598 5.75221 13.0199 5.62162 13.0055C5.49103 12.9912 5.35889 13.0027 5.23275 13.0394C5.10661 13.0762 4.98894 13.1374 4.88646 13.2196C4.78399 13.3018 4.69871 13.4034 4.6355 13.5186C4.57229 13.6338 4.53238 13.7603 4.51806 13.8909C4.50374 14.0215 4.51529 14.1536 4.55204 14.2797C4.58879 14.4059 4.65003 14.5235 4.73226 14.626C6.37928 16.6793 8.91557 18 11.7498 18C16.4054 18 20.2508 14.4376 20.7039 9.89844L21.2928 10.4873C21.385 10.5833 21.4953 10.6599 21.6174 10.7127C21.7396 10.7655 21.871 10.7934 22.0041 10.7947C22.1371 10.7961 22.2691 10.7709 22.3922 10.7206C22.5154 10.6703 22.6273 10.5959 22.7214 10.5018C22.8155 10.4078 22.8898 10.2959 22.9401 10.1727C22.9904 10.0495 23.0156 9.91753 23.0143 9.78449C23.0129 9.65145 22.985 9.52001 22.9322 9.39788C22.8795 9.27576 22.8028 9.16539 22.7069 9.07324L20.4569 6.82324C20.3623 6.72862 20.2497 6.65394 20.1257 6.60362C20.0018 6.55329 19.869 6.52835 19.7352 6.53027Z"
                    fill="#63B15B"
                  />
                </svg>
              </p>
            </div>
            <div v-if="!loggedIn" class="w-1/4 wish_block">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                @click="
                  showNotification({
                    desc: $t('pages.showNotification.info.description'),
                    buttons: {
                      okay: {
                        text: $t('pages.showNotification.info.button.okay'),
                      },
                    },
                  })
                "
              >
                <path
                  d="M10 0C4.48603 0 0 4.48604 0 10C0 15.514 4.48603 20 10 20C15.514 20 20 15.514 20 10C20 4.48604 15.514 0 10 0ZM10 1.5C14.7033 1.5 18.5 5.2967 18.5 10C18.5 14.7033 14.7033 18.5 10 18.5C5.29669 18.5 1.5 14.7033 1.5 10C1.5 5.2967 5.29669 1.5 10 1.5ZM10 5C9.73478 5 9.48043 5.10536 9.29289 5.29289C9.10536 5.48043 9 5.73478 9 6C9 6.26522 9.10536 6.51957 9.29289 6.70711C9.48043 6.89464 9.73478 7 10 7C10.2652 7 10.5196 6.89464 10.7071 6.70711C10.8946 6.51957 11 6.26522 11 6C11 5.73478 10.8946 5.48043 10.7071 5.29289C10.5196 5.10536 10.2652 5 10 5ZM9.98828 8.48926C9.78954 8.49236 9.60016 8.57423 9.46173 8.71686C9.3233 8.8595 9.24715 9.05125 9.25 9.25V14.75C9.24859 14.8494 9.26696 14.9481 9.30402 15.0403C9.34108 15.1325 9.3961 15.2164 9.46588 15.2872C9.53566 15.358 9.61882 15.4142 9.71051 15.4526C9.8022 15.4909 9.90061 15.5107 10 15.5107C10.0994 15.5107 10.1978 15.4909 10.2895 15.4526C10.3812 15.4142 10.4643 15.358 10.5341 15.2872C10.6039 15.2164 10.6589 15.1325 10.696 15.0403C10.733 14.9481 10.7514 14.8494 10.75 14.75V9.25C10.7514 9.14962 10.7327 9.04997 10.6949 8.95695C10.6571 8.86394 10.6011 8.77946 10.53 8.70852C10.459 8.63758 10.3745 8.58161 10.2814 8.54395C10.1883 8.50629 10.0887 8.48769 9.98828 8.48926Z"
                  fill="#676666"
                />
              </svg>
            </div>
          </div>

          <div class="filter-item_block relative">
            <div
              class="
                font-bold
                text-sm
                font-bold
                text-darkblack
                mb-2.5
                flex
                justify-between
                items-center
                relative
              "
            >
              <div class="text">
                {{ $t("pages.filters.heading") }}
              </div>
              <div v-if="loggedIn" class="infoicon">
                <span @click="InfoModal">
                  <svg
                    class="w-5 h-5"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 0C4.48603 0 0 4.48604 0 10C0 15.514 4.48603 20 10 20C15.514 20 20 15.514 20 10C20 4.48604 15.514 0 10 0ZM10 1.5C14.7033 1.5 18.5 5.2967 18.5 10C18.5 14.7033 14.7033 18.5 10 18.5C5.29669 18.5 1.5 14.7033 1.5 10C1.5 5.2967 5.29669 1.5 10 1.5ZM10 5C9.73478 5 9.48043 5.10536 9.29289 5.29289C9.10536 5.48043 9 5.73478 9 6C9 6.26522 9.10536 6.51957 9.29289 6.70711C9.48043 6.89464 9.73478 7 10 7C10.2652 7 10.5196 6.89464 10.7071 6.70711C10.8946 6.51957 11 6.26522 11 6C11 5.73478 10.8946 5.48043 10.7071 5.29289C10.5196 5.10536 10.2652 5 10 5ZM9.98828 8.48926C9.78954 8.49236 9.60016 8.57423 9.46173 8.71686C9.3233 8.8595 9.24715 9.05125 9.25 9.25V14.75C9.24859 14.8494 9.26696 14.9481 9.30402 15.0403C9.34108 15.1325 9.3961 15.2164 9.46588 15.2872C9.53566 15.358 9.61882 15.4142 9.71051 15.4526C9.8022 15.4909 9.90061 15.5107 10 15.5107C10.0994 15.5107 10.1978 15.4909 10.2895 15.4526C10.3812 15.4142 10.4643 15.358 10.5341 15.2872C10.6039 15.2164 10.6589 15.1325 10.696 15.0403C10.733 14.9481 10.7514 14.8494 10.75 14.75V9.25C10.7514 9.14962 10.7327 9.04997 10.6949 8.95695C10.6571 8.86394 10.6011 8.77946 10.53 8.70852C10.459 8.63758 10.3745 8.58161 10.2814 8.54395C10.1883 8.50629 10.0887 8.48769 9.98828 8.48926Z"
                      fill="#C6C6D1"
                    />
                  </svg>
                </span>
              </div>
              <div
                v-if="loggedIn && isInfoModal"
                class="
                  info-model
                  bg-white
                  pl-4
                  pr-4
                  pt-3
                  pb-4
                  absolute
                  right-0
                  top-full
                  w-75
                  z-50
                "
              >
                <label class="flex justify-between items-center mb-1">
                  <span
                    class="
                      text
                      block
                      font-bold
                      text-sm text-darkgray
                      block
                      w-4/6
                    "
                  >
                    Info
                  </span>
                  <span class="flex justify-end items-center w-2/6">
                    <span @click="InfoModal">
                      <svg
                        width="16"
                        height="16"
                        class="w-4 h-4"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.1622 2.32631C13.0301 2.32943 12.9047 2.38467 12.8132 2.47996L8.00008 7.29311L3.18693 2.47996C3.14032 2.43196 3.08456 2.39381 3.02294 2.36775C2.96132 2.34169 2.8951 2.32827 2.8282 2.32826C2.7287 2.32829 2.63146 2.358 2.54893 2.4136C2.46641 2.4692 2.40234 2.54815 2.36494 2.64036C2.32754 2.73257 2.3185 2.83385 2.33898 2.93122C2.35946 3.0286 2.40852 3.11765 2.4799 3.18699L7.29305 8.00014L2.4799 12.8133C2.43191 12.8594 2.3936 12.9146 2.36721 12.9756C2.34082 13.0367 2.32687 13.1024 2.3262 13.1689C2.32552 13.2354 2.33812 13.3014 2.36327 13.363C2.38841 13.4246 2.42559 13.4805 2.47263 13.5276C2.51967 13.5746 2.57562 13.6118 2.63721 13.637C2.6988 13.6621 2.76479 13.6747 2.83131 13.674C2.89783 13.6733 2.96354 13.6594 3.02461 13.633C3.08567 13.6066 3.14085 13.5683 3.18693 13.5203L8.00008 8.70717L12.8132 13.5203C12.8593 13.5683 12.9145 13.6066 12.9755 13.633C13.0366 13.6594 13.1023 13.6733 13.1688 13.674C13.2354 13.6747 13.3014 13.6621 13.3629 13.6369C13.4245 13.6118 13.4805 13.5746 13.5275 13.5276C13.5746 13.4805 13.6117 13.4246 13.6369 13.363C13.662 13.3014 13.6746 13.2354 13.674 13.1689C13.6733 13.1024 13.6593 13.0367 13.6329 12.9756C13.6066 12.9146 13.5682 12.8594 13.5203 12.8133L8.70711 8.00014L13.5203 3.18699C13.593 3.1172 13.6429 3.02707 13.6635 2.92842C13.6841 2.82977 13.6744 2.72719 13.6357 2.63414C13.597 2.54109 13.531 2.46191 13.4466 2.40698C13.3621 2.35205 13.2629 2.32393 13.1622 2.32631Z"
                          fill="#63B15B"
                        />
                      </svg>
                    </span>
                  </span>
                </label>
                <p class="text-sm font-normal pr-4.5">
                  {{ $t("pages.filters.info") }}
                </p>
              </div>
            </div>
            <div class="flex justify-between items-center filoption-block">
              <a
                class="
                  w-full
                  h-full
                  flex
                  items-center
                  justify-center
                  btn_action
                  left
                "
                :class="{ active: filters.patient === 1 }"
                @click="filters.patient = 1"
              >
                {{ $t("pages.filters.patient") }}
              </a>
              <a
                class="
                  w-full
                  h-full
                  flex
                  items-center
                  justify-center
                  btn_action
                  right
                "
                :class="{ active: filters.patient === 2 }"
                @click="filters.patient = 2"
              >
                {{ $t("pages.filters.patients") }}
                <svg
                  width="14"
                  height="13"
                  viewBox="0 0 14 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  @click.stop="
                    showNotification({
                      heading: $t('pages.common.buttons.buttontext1'),
                      desc: $t('pages.common.buttons.buttontext2'),
                      icon: {
                        show: true,
                      },
                      buttons: {
                        okay: {
                          text: 'Ok',
                        },
                      },
                    })
                  "
                >
                  <path
                    d="M0.833008 12.5V5H13.833V12.5H0.833008ZM2.83301 11.5H11.833C11.833 10.9473 12.2803 10.5 12.833 10.5V7C12.2803 7 11.833 6.55273 11.833 6H2.83301C2.83301 6.55273 2.38574 7 1.83301 7V10.5C2.38574 10.5 2.83301 10.9473 2.83301 11.5ZM7.33301 11C6.22754 11 5.33301 9.99219 5.33301 8.75C5.33301 7.50781 6.22754 6.5 7.33301 6.5C8.43848 6.5 9.33301 7.50781 9.33301 8.75C9.33301 9.99219 8.43848 11 7.33301 11ZM7.33301 10C7.88379 10 8.33301 9.43945 8.33301 8.75C8.33301 8.06055 7.88379 7.5 7.33301 7.5C6.78223 7.5 6.33301 8.06055 6.33301 8.75C6.33301 9.43945 6.78223 10 7.33301 10ZM3.58301 9.5C3.16895 9.5 2.83301 9.16406 2.83301 8.75C2.83301 8.33594 3.16895 8 3.58301 8C3.99707 8 4.33301 8.33594 4.33301 8.75C4.33301 9.16406 3.99707 9.5 3.58301 9.5ZM11.083 9.5C10.6689 9.5 10.333 9.16406 10.333 8.75C10.333 8.33594 10.6689 8 11.083 8C11.4971 8 11.833 8.33594 11.833 8.75C11.833 9.16406 11.4971 9.5 11.083 9.5ZM6.83301 4V2.5H4.83301L7.33301 0L9.83301 2.5H7.83301V4H6.83301Z"
                    :fill="filters.patient === 2 ? '#ffffff' : '#63B15B'"
                  />
                </svg>
              </a>
            </div>
            <div class="filter_list_block">
              <div
                v-for="(dd, ddKey) in dropDown.genders"
                :key="ddKey"
                class="flex justify-between items-center filtermenu_block"
                :class="{ 'opacity-50': !loggedIn && ddKey === 2 }"
              >
                <div class="w-4/5 left_block">
                  <div class="iconbox">
                    <label class="custome_radio">
                      <input
                        v-model="filters.gender"
                        type="radio"
                        :value="ddKey"
                        name="gender"
                      />
                      <span class="checkmark"></span>
                      <span class="font-medium"> {{ dd }} </span>
                    </label>
                  </div>
                </div>
                <div class="flex items-center justify-end w-1/5 right_block">
                  <svg
                    v-if="ddKey === 0"
                    width="18"
                    height="18"
                    class="h-4-5 w-4-5"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.75 0V1.5H15.4219L9.65625 7.26562C8.64258 6.4834 7.37402 6 6 6C2.69531 6 0 8.69531 0 12C0 15.3047 2.69531 18 6 18C9.30469 18 12 15.3047 12 12C12 10.626 11.5166 9.35742 10.7344 8.34375L16.5 2.57812V8.25H18V0H9.75ZM6 7.5C8.49316 7.5 10.5 9.50684 10.5 12C10.5 14.4932 8.49316 16.5 6 16.5C3.50684 16.5 1.5 14.4932 1.5 12C1.5 9.50684 3.50684 7.5 6 7.5Z"
                      fill="#676666"
                    />
                  </svg>

                  <svg
                    v-if="ddKey === 1"
                    width="12"
                    height="20"
                    class="h-4-5 w-4-5"
                    viewBox="0 0 12 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6 0.25C2.69531 0.25 0 2.94531 0 6.25C0 9.2998 2.2998 11.8281 5.25 12.2031V15.25H2.25V16.75H5.25V19.75H6.75V16.75H9.75V15.25H6.75V12.2031C9.7002 11.8281 12 9.2998 12 6.25C12 2.94531 9.30469 0.25 6 0.25ZM6 1.75C8.49316 1.75 10.5 3.75684 10.5 6.25C10.5 8.74316 8.49316 10.75 6 10.75C3.50684 10.75 1.5 8.74316 1.5 6.25C1.5 3.75684 3.50684 1.75 6 1.75Z"
                      fill="#676666"
                    />
                  </svg>

                  <svg
                    v-if="ddKey === 2"
                    width="20"
                    height="19"
                    class="h-4-5 w-4-5"
                    viewBox="0 0 20 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.5 0.5C3.5625 0.5 2.76441 0.878567 2.25195 1.45508C1.7395 2.03159 1.5 2.77083 1.5 3.5C1.5 4.22917 1.7395 4.96841 2.25195 5.54492C2.76441 6.12143 3.5625 6.5 4.5 6.5C5.4375 6.5 6.23559 6.12143 6.74805 5.54492C7.2605 4.96841 7.5 4.22917 7.5 3.5C7.5 2.77083 7.2605 2.03159 6.74805 1.45508C6.23559 0.878567 5.4375 0.5 4.5 0.5ZM15.5 0.5C14.5625 0.5 13.7644 0.878567 13.252 1.45508C12.7395 2.03159 12.5 2.77083 12.5 3.5C12.5 4.22917 12.7395 4.96841 13.252 5.54492C13.7644 6.12143 14.5625 6.5 15.5 6.5C16.4375 6.5 17.2356 6.12143 17.748 5.54492C18.2605 4.96841 18.5 4.22917 18.5 3.5C18.5 2.77083 18.2605 2.03159 17.748 1.45508C17.2356 0.878567 16.4375 0.5 15.5 0.5ZM4.5 2C5.0625 2 5.38941 2.18393 5.62695 2.45117C5.8645 2.71841 6 3.10417 6 3.5C6 3.89583 5.8645 4.28159 5.62695 4.54883C5.38941 4.81607 5.0625 5 4.5 5C3.9375 5 3.61059 4.81607 3.37305 4.54883C3.1355 4.28159 3 3.89583 3 3.5C3 3.10417 3.1355 2.71841 3.37305 2.45117C3.61059 2.18393 3.9375 2 4.5 2ZM15.5 2C16.0625 2 16.3894 2.18393 16.627 2.45117C16.8645 2.71841 17 3.10417 17 3.5C17 3.89583 16.8645 4.28159 16.627 4.54883C16.3894 4.81607 16.0625 5 15.5 5C14.9375 5 14.6106 4.81607 14.373 4.54883C14.1355 4.28159 14 3.89583 14 3.5C14 3.10417 14.1355 2.71841 14.373 2.45117C14.6106 2.18393 14.9375 2 15.5 2ZM10 5.5C9.0625 5.5 8.26441 5.87857 7.75195 6.45508C7.2395 7.03159 7 7.77083 7 8.5C7 9.22917 7.2395 9.96841 7.75195 10.5449C8.26441 11.1214 9.0625 11.5 10 11.5C10.9375 11.5 11.7356 11.1214 12.248 10.5449C12.7605 9.96841 13 9.22917 13 8.5C13 7.77083 12.7605 7.03159 12.248 6.45508C11.7356 5.87857 10.9375 5.5 10 5.5ZM10 7C10.5625 7 10.8894 7.18393 11.127 7.45117C11.3645 7.71841 11.5 8.10417 11.5 8.5C11.5 8.89583 11.3645 9.28159 11.127 9.54883C10.8894 9.81607 10.5625 10 10 10C9.4375 10 9.11059 9.81607 8.87305 9.54883C8.6355 9.28159 8.5 8.89583 8.5 8.5C8.5 8.10417 8.6355 7.71841 8.87305 7.45117C9.11059 7.18393 9.4375 7 10 7ZM1.75 7.5C0.785 7.5 0 8.285 0 9.25V10.5C0 12.18 1.975 13.5 4.5 13.5H4.60547C4.83047 12.695 5.41969 12.0398 6.17969 11.7148C5.70469 11.8898 5.13 12 4.5 12C2.785 12 1.5 11.21 1.5 10.5V9.25C1.5 9.11 1.61 9 1.75 9H6.03027C6.01027 8.835 6 8.67 6 8.5C6 8.155 6.045 7.82 6.125 7.5H1.75ZM13.875 7.5C13.955 7.82 14 8.155 14 8.5C14 8.67 13.9897 8.835 13.9697 9H18.25C18.39 9 18.5 9.11 18.5 9.25V10.5C18.5 11.21 17.215 12 15.5 12C14.87 12 14.2953 11.8898 13.8203 11.7148C14.5803 12.0398 15.1695 12.695 15.3945 13.5H15.5C18.025 13.5 20 12.18 20 10.5V9.25C20 8.285 19.215 7.5 18.25 7.5H13.875ZM7.25 12.5C6.29252 12.5 5.5 13.2925 5.5 14.25V15.5C5.5 16.4591 6.13996 17.2406 6.96289 17.7344C7.78582 18.2281 8.84288 18.5 10 18.5C11.1571 18.5 12.2142 18.2281 13.0371 17.7344C13.86 17.2406 14.5 16.4591 14.5 15.5V14.25C14.5 13.2925 13.7075 12.5 12.75 12.5H7.25ZM7.25 14H12.75C12.8975 14 13 14.1025 13 14.25V15.5C13 15.7834 12.7999 16.1276 12.2656 16.4482C11.7313 16.7688 10.9139 17 10 17C9.08612 17 8.26869 16.7688 7.73438 16.4482C7.20006 16.1276 7 15.7834 7 15.5V14.25C7 14.1025 7.10248 14 7.25 14Z"
                      fill="#676666"
                    />
                  </svg>
                </div>
              </div>

              <div
                class="
                  flex
                  justify-between
                  items-center
                  filtermenu_block filtermenu_block1
                "
                :class="{ 'opacity-50': !loggedIn }"
              >
                <div class="flex left_block">
                  <div class="iconbox">
                    <label class="custome_check">
                      <input
                        v-model="filters.other_people_in_household"
                        type="checkbox"
                        :disabled="!loggedIn"
                      />
                      <span class="checkmark"></span>
                      <span class="font-medium">
                        {{
                          $t(
                            "pages.filters.general.other_people_in_the_household.text"
                          )
                        }}
                      </span>
                    </label>
                  </div>
                  <div class="iconbox" @click="showNotification">
                    <svg
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.333008 12.5V5H13.333V12.5H0.333008ZM2.33301 11.5H11.333C11.333 10.9473 11.7803 10.5 12.333 10.5V7C11.7803 7 11.333 6.55273 11.333 6H2.33301C2.33301 6.55273 1.88574 7 1.33301 7V10.5C1.88574 10.5 2.33301 10.9473 2.33301 11.5ZM6.83301 11C5.72754 11 4.83301 9.99219 4.83301 8.75C4.83301 7.50781 5.72754 6.5 6.83301 6.5C7.93848 6.5 8.83301 7.50781 8.83301 8.75C8.83301 9.99219 7.93848 11 6.83301 11ZM6.83301 10C7.38379 10 7.83301 9.43945 7.83301 8.75C7.83301 8.06055 7.38379 7.5 6.83301 7.5C6.28223 7.5 5.83301 8.06055 5.83301 8.75C5.83301 9.43945 6.28223 10 6.83301 10ZM3.08301 9.5C2.66895 9.5 2.33301 9.16406 2.33301 8.75C2.33301 8.33594 2.66895 8 3.08301 8C3.49707 8 3.83301 8.33594 3.83301 8.75C3.83301 9.16406 3.49707 9.5 3.08301 9.5ZM10.583 9.5C10.1689 9.5 9.83301 9.16406 9.83301 8.75C9.83301 8.33594 10.1689 8 10.583 8C10.9971 8 11.333 8.33594 11.333 8.75C11.333 9.16406 10.9971 9.5 10.583 9.5ZM6.33301 4V2.5H4.33301L6.83301 0L9.33301 2.5H7.33301V4H6.33301Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </div>
                </div>
                <div
                  class="flex items-center justify-end w-1/5 right_block"
                ></div>
              </div>
            </div>
          </div>

          <div class="filter-item_block">
            <p
              class="
                font-bold
                text-sm
                font-bold
                text-darkblack
                filter_title
                mb-2.5
              "
            >
              {{ $t("pages.filters.mobility.heading") }}
            </p>
            <div class="filter_list_block">
              <div
                class="flex justify-between items-center filtermenu_block"
                :class="{ 'opacity-50': !loggedIn }"
              >
                <div class="w-4/5 left_block">
                  <div class="iconbox">
                    <label class="custome_check">
                      <input
                        v-model="filters.mobility.wheelchair"
                        type="checkbox"
                        :disabled="!loggedIn"
                      />
                      <span class="checkmark"></span>
                      <span class="font-medium">
                        {{ $t("pages.filters.mobility.wheelchair") }}
                      </span>
                    </label>
                  </div>
                </div>
                <div class="flex items-center justify-end w-1/5 right_block">
                  <svg
                    width="16"
                    height="19"
                    class="h-4-5 w-4-5"
                    viewBox="0 0 16 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.499 0C9.39502 0 8.5 0.896023 8.5 1.99902C8.5 3.10402 9.39502 4 10.499 4C11.6055 4 12.5 3.10402 12.5 1.99902C12.5 0.896023 11.6055 0 10.499 0ZM7.87305 3.87988C7.85805 3.87988 7.84508 3.88329 7.83008 3.88379C7.34158 3.90079 5.3183 3.97745 4.2373 4.10645C3.5893 4.18395 3.04159 4.61023 2.80859 5.21973L1.79883 7.8623C1.65083 8.24881 1.84444 8.68305 2.23145 8.83105C2.28095 8.85005 2.33184 8.8504 2.38184 8.8584C0.950336 9.7959 0 11.413 0 13.25C0 16.145 2.355 18.5 5.25 18.5C7.2515 18.5 8.99291 17.3737 9.87891 15.7227L11.6611 17.3682C11.7531 17.4527 11.8745 17.5 12 17.5H15C15.2765 17.5 15.5 17.2765 15.5 17C15.5 16.7235 15.2765 16.5 15 16.5H12.1953L10.2832 14.7354C10.4222 14.2639 10.5 13.766 10.5 13.25C10.5 12.9945 10.4759 12.7455 10.4404 12.5H12L14 15.5L14.0352 15.4863L14.0596 15.543C14.1811 15.8285 14.459 16 14.751 16C14.8485 16 14.948 15.9809 15.043 15.9404C15.4245 15.7784 15.6019 15.338 15.4404 14.957L13.6904 10.8369C13.5814 10.5804 13.34 10.4053 13.0625 10.3818L12.8047 10.3604L9.34375 9.86816L9.89062 6.64746C9.95562 6.44296 10.001 6.22991 10.001 6.00391V6.00195L10 6L9.99902 5.99902C9.99702 4.93002 9.20242 4.05418 8.16992 3.90918C8.09642 3.88868 8.02045 3.87588 7.93945 3.87988C7.93295 3.87988 7.91753 3.88084 7.89453 3.88184C7.88703 3.88184 7.88055 3.87988 7.87305 3.87988ZM4.35742 5.61914L5.5 6L5.42578 8.00879C5.36678 8.00679 5.3095 8 5.25 8C4.517 8 3.81857 8.1523 3.18457 8.4248C3.18857 8.4148 3.1967 8.40746 3.2002 8.39746L4.20996 5.75488C4.23596 5.68788 4.29242 5.64514 4.35742 5.61914ZM5.25 9.5C7.318 9.5 9 11.182 9 13.25C9 15.318 7.318 17 5.25 17C3.182 17 1.5 15.318 1.5 13.25C1.5 11.182 3.182 9.5 5.25 9.5ZM5.25 12.5C5.05109 12.5 4.86032 12.579 4.71967 12.7197C4.57902 12.8603 4.5 13.0511 4.5 13.25C4.5 13.4489 4.57902 13.6397 4.71967 13.7803C4.86032 13.921 5.05109 14 5.25 14C5.44891 14 5.63968 13.921 5.78033 13.7803C5.92098 13.6397 6 13.4489 6 13.25C6 13.0511 5.92098 12.8603 5.78033 12.7197C5.63968 12.579 5.44891 12.5 5.25 12.5Z"
                      fill="#676666"
                    />
                  </svg>
                </div>
              </div>

              <div
                class="flex justify-between items-center filtermenu_block"
                :class="{ 'opacity-50': !loggedIn }"
              >
                <div class="flex w-4/5 left_block">
                  <div class="iconbox">
                    <label class="custome_check">
                      <input
                        v-model="filters.mobility.bedridden"
                        type="checkbox"
                        :disabled="!loggedIn"
                      />
                      <span class="checkmark"></span>
                      <span class="font-medium">
                        {{ $t("pages.filters.mobility.bedridden") }}
                      </span>
                    </label>
                  </div>
                </div>
                <div class="flex items-center justify-end w-1/5 right_block">
                  <svg
                    width="22"
                    height="18"
                    viewBox="0 0 22 18"
                    class="h-4-5 w-4-5"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.75015 0.5C4.24027 0.5 3.00015 1.74011 3.00015 3.25V6.65332C1.85867 6.98802 1.00015 8.0056 1.00015 9.25V13.627C0.986928 13.7075 0.986928 13.7896 1.00015 13.8701V16.75C0.998748 16.8494 1.01711 16.9481 1.05417 17.0403C1.09123 17.1325 1.14625 17.2164 1.21603 17.2872C1.28582 17.358 1.36897 17.4142 1.46066 17.4526C1.55236 17.4909 1.65076 17.5107 1.75015 17.5107C1.84955 17.5107 1.94795 17.4909 2.03964 17.4526C2.13134 17.4142 2.21449 17.358 2.28427 17.2872C2.35406 17.2164 2.40908 17.1325 2.44614 17.0403C2.4832 16.9481 2.50156 16.8494 2.50015 16.75V14.5H19.5002V16.75C19.4987 16.8494 19.5171 16.9481 19.5542 17.0403C19.5912 17.1325 19.6462 17.2164 19.716 17.2872C19.7858 17.358 19.869 17.4142 19.9607 17.4526C20.0524 17.4909 20.1508 17.5107 20.2502 17.5107C20.3495 17.5107 20.448 17.4909 20.5396 17.4526C20.6313 17.4142 20.7145 17.358 20.7843 17.2872C20.8541 17.2164 20.9091 17.1325 20.9461 17.0403C20.9832 16.9481 21.0016 16.8494 21.0002 16.75V13.873C21.0134 13.7925 21.0134 13.7104 21.0002 13.6299V9.25C21.0002 8.0056 20.1416 6.98802 19.0002 6.65332V3.25C19.0002 1.74011 17.76 0.5 16.2502 0.5H5.75015ZM5.75015 2H16.2502C16.9493 2 17.5002 2.55089 17.5002 3.25V6.5H16.0002C16.0002 5.9475 15.5527 5.5 15.0002 5.5H13.0002C12.4477 5.5 12.0002 5.9475 12.0002 6.5H10.0002C10.0002 5.9475 9.55265 5.5 9.00015 5.5H7.00015C6.44765 5.5 6.00015 5.9475 6.00015 6.5H4.50015V3.25C4.50015 2.55089 5.05104 2 5.75015 2ZM3.87027 8H18.1271C18.1758 8.0081 18.2252 8.01137 18.2746 8.00977C18.96 8.0246 19.5002 8.56048 19.5002 9.25V13H2.50015V9.25C2.50015 8.55982 3.04132 8.0236 3.72769 8.00977C3.77542 8.01106 3.82316 8.00779 3.87027 8Z"
                      fill="#676666"
                    />
                  </svg>
                </div>
              </div>

              <div
                class="flex justify-between items-center filtermenu_block"
                :class="{ 'opacity-50': !loggedIn }"
              >
                <div class="flex w-4/5 left_block">
                  <div class="iconbox">
                    <label class="custome_check">
                      <input
                        v-model="filters.mobility.mobile"
                        type="checkbox"
                        :disabled="!loggedIn"
                      />
                      <span class="checkmark"></span>
                      <span class="font-medium">
                        {{ $t("pages.filters.mobility.mobile") }}
                      </span>
                    </label>
                  </div>
                </div>
                <div class="flex items-center justify-end w-1/5 right_block">
                  <svg
                    width="13"
                    height="20"
                    viewBox="0 0 13 20"
                    class="h-4-5 w-4-5"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.50023 0.5C8.9698 0.5 8.46109 0.710714 8.08602 1.08579C7.71095 1.46086 7.50023 1.96957 7.50023 2.5C7.50023 3.03043 7.71095 3.53914 8.08602 3.91421C8.46109 4.28929 8.9698 4.5 9.50023 4.5C10.0307 4.5 10.5394 4.28929 10.9144 3.91421C11.2895 3.53914 11.5002 3.03043 11.5002 2.5C11.5002 1.96957 11.2895 1.46086 10.9144 1.08579C10.5394 0.710714 10.0307 0.5 9.50023 0.5ZM5.50023 3.5C5.14253 3.50043 4.7915 3.59679 4.4837 3.77903C4.17591 3.96126 3.92262 4.22271 3.75023 4.53613L3.7473 4.53418L1.25218 9.0293L1.25414 9.03027C1.01144 9.46815 0.941797 9.98113 1.05896 10.4679C1.17613 10.9546 1.47158 11.3797 1.88695 11.6592L5.55687 14.5283L6.00219 18.8037L6.00414 18.8242C6.01125 18.9242 6.03834 19.0218 6.08382 19.1112C6.1293 19.2006 6.19223 19.2799 6.26891 19.3446C6.34559 19.4092 6.43445 19.4578 6.53023 19.4875C6.62602 19.5172 6.72679 19.5274 6.82658 19.5174C6.92637 19.5075 7.02315 19.4777 7.11121 19.4297C7.19927 19.3817 7.27681 19.3166 7.33925 19.2381C7.4017 19.1596 7.44777 19.0694 7.47475 18.9729C7.50173 18.8763 7.50906 18.7753 7.49633 18.6758L7.02269 13.9404C7.02269 13.9401 7.02269 13.9398 7.02269 13.9395C6.99209 13.6361 6.88291 13.3461 6.70531 13.0977L4.93969 10.626L6.80883 7.26172L8.45726 9.06445L10.2961 11.2344C10.3651 11.3203 10.4521 11.39 10.551 11.4385L11.5041 19.0625C11.5116 19.1282 11.5321 19.1918 11.5644 19.2496C11.5966 19.3074 11.64 19.3582 11.692 19.399C11.7441 19.4399 11.8037 19.4701 11.8674 19.4877C11.9312 19.5054 11.9978 19.5102 12.0635 19.502C12.1291 19.4937 12.1925 19.4725 12.2498 19.4395C12.3072 19.4066 12.3575 19.3626 12.3978 19.3101C12.438 19.2576 12.4675 19.1977 12.4844 19.1337C12.5013 19.0697 12.5054 19.003 12.4963 18.9375L11.5237 11.1562C11.6073 11.0186 11.6444 10.8576 11.6295 10.6972C11.6145 10.5368 11.5483 10.3855 11.4407 10.2656L9.35375 7.80176L7.31078 4.65234C7.14968 4.30807 6.89382 4.01684 6.57316 3.81275C6.2525 3.60866 5.88033 3.50018 5.50023 3.5ZM1.71801 12.9043L1.8889 14.5742L1.35277 16.3398L0.548083 18.4863C0.51211 18.5788 0.494849 18.6775 0.497299 18.7767C0.499749 18.8759 0.521863 18.9737 0.562358 19.0643C0.602853 19.1549 0.660924 19.2366 0.733208 19.3046C0.805491 19.3725 0.89055 19.4255 0.983456 19.4604C1.07636 19.4953 1.17527 19.5114 1.27444 19.5078C1.37361 19.5042 1.47109 19.4809 1.56121 19.4394C1.65133 19.3978 1.73231 19.3388 1.79946 19.2657C1.8666 19.1927 1.91858 19.107 1.95238 19.0137L3.45238 15.0137C3.49651 14.9007 3.5126 14.7787 3.49926 14.6582V14.2979L1.71801 12.9043Z"
                      fill="#676666"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <div class="filter-item_block">
            <p
              class="
                font-bold
                text-sm
                font-bold
                text-darkblack
                font-bold
                filter_title
                mb-2.5
              "
            >
              {{ $t("pages.filters.night_work.heading") }}
            </p>
            <div class="filter_list_block">
              <div
                class="flex justify-between items-center filtermenu_block"
                :class="{ 'opacity-50': !loggedIn }"
              >
                <div class="flex w-4/5 left_block">
                  <div class="iconbox">
                    <label class="custome_check">
                      <input
                        v-model="filters.night_work.little"
                        type="checkbox"
                        :disabled="!loggedIn"
                      />
                      <span class="checkmark"></span>
                      <span class="font-medium">
                        {{ $t("pages.filters.night_work.little") }}
                      </span>
                    </label>
                  </div>
                </div>
                <div class="flex items-center justify-end w-1/5 right_block">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    class="h-4-5 w-4-5"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 0C4.03711 0 0 4.03711 0 9C0 13.9629 4.03711 18 9 18C13.9629 18 18 13.9629 18 9C18 4.03711 13.9629 0 9 0ZM9 1.5C13.1514 1.5 16.5 4.84863 16.5 9C16.5 13.1514 13.1514 16.5 9 16.5C8.70703 16.5 8.41699 16.4619 8.13281 16.4297C7.02539 15.2578 5.25 12.8057 5.25 9C5.25 5.19434 7.02539 2.74219 8.13281 1.57031C8.41699 1.53809 8.70703 1.5 9 1.5Z"
                      fill="#676666"
                    />
                  </svg>
                </div>
              </div>

              <div
                class="flex justify-between items-center filtermenu_block"
                :class="{ 'opacity-50': !loggedIn }"
              >
                <div class="flex w-4/5 left_block">
                  <div class="iconbox">
                    <label class="custome_check">
                      <input
                        v-model="filters.night_work.medium"
                        type="checkbox"
                        :disabled="!loggedIn"
                      />
                      <span class="checkmark"></span>
                      <span class="font-medium">
                        {{ $t("pages.filters.night_work.medium.text") }}
                      </span>
                    </label>
                  </div>
                  <div class="iconbox" @click="showNotification">
                    <svg
                      width="14"
                      height="13"
                      class="h-4-5 w-4-5"
                      viewBox="0 0 14 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.333008 12.5V5H13.333V12.5H0.333008ZM2.33301 11.5H11.333C11.333 10.9473 11.7803 10.5 12.333 10.5V7C11.7803 7 11.333 6.55273 11.333 6H2.33301C2.33301 6.55273 1.88574 7 1.33301 7V10.5C1.88574 10.5 2.33301 10.9473 2.33301 11.5ZM6.83301 11C5.72754 11 4.83301 9.99219 4.83301 8.75C4.83301 7.50781 5.72754 6.5 6.83301 6.5C7.93848 6.5 8.83301 7.50781 8.83301 8.75C8.83301 9.99219 7.93848 11 6.83301 11ZM6.83301 10C7.38379 10 7.83301 9.43945 7.83301 8.75C7.83301 8.06055 7.38379 7.5 6.83301 7.5C6.28223 7.5 5.83301 8.06055 5.83301 8.75C5.83301 9.43945 6.28223 10 6.83301 10ZM3.08301 9.5C2.66895 9.5 2.33301 9.16406 2.33301 8.75C2.33301 8.33594 2.66895 8 3.08301 8C3.49707 8 3.83301 8.33594 3.83301 8.75C3.83301 9.16406 3.49707 9.5 3.08301 9.5ZM10.583 9.5C10.1689 9.5 9.83301 9.16406 9.83301 8.75C9.83301 8.33594 10.1689 8 10.583 8C10.9971 8 11.333 8.33594 11.333 8.75C11.333 9.16406 10.9971 9.5 10.583 9.5ZM6.33301 4V2.5H4.33301L6.83301 0L9.33301 2.5H7.33301V4H6.33301Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </div>
                </div>
                <div class="flex items-center justify-end w-1/5 right_block">
                  <svg
                    width="18"
                    height="18"
                    class="h-4-5 w-4-5"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 0C4.03711 0 0 4.03711 0 9C0 13.9629 4.03711 18 9 18C13.9629 18 18 13.9629 18 9C18 4.03711 13.9629 0 9 0ZM9 1.5C13.1514 1.5 16.5 4.84863 16.5 9C16.5 13.1514 13.1514 16.5 9 16.5V1.5Z"
                      fill="#676666"
                    />
                  </svg>
                </div>
              </div>

              <div
                class="flex justify-between items-center filtermenu_block"
                :class="{ 'opacity-50': !loggedIn }"
              >
                <div class="flex w-4/5 left_block">
                  <div class="iconbox">
                    <label class="custome_check">
                      <input
                        v-model="filters.night_work.much"
                        type="checkbox"
                        :disabled="!loggedIn"
                      />
                      <span class="checkmark"></span>
                      <span class="font-medium">
                        {{ $t("pages.filters.night_work.much.text") }}
                      </span>
                    </label>
                  </div>
                  <div class="iconbox" @click="showNotification">
                    <svg
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.333008 12.5V5H13.333V12.5H0.333008ZM2.33301 11.5H11.333C11.333 10.9473 11.7803 10.5 12.333 10.5V7C11.7803 7 11.333 6.55273 11.333 6H2.33301C2.33301 6.55273 1.88574 7 1.33301 7V10.5C1.88574 10.5 2.33301 10.9473 2.33301 11.5ZM6.83301 11C5.72754 11 4.83301 9.99219 4.83301 8.75C4.83301 7.50781 5.72754 6.5 6.83301 6.5C7.93848 6.5 8.83301 7.50781 8.83301 8.75C8.83301 9.99219 7.93848 11 6.83301 11ZM6.83301 10C7.38379 10 7.83301 9.43945 7.83301 8.75C7.83301 8.06055 7.38379 7.5 6.83301 7.5C6.28223 7.5 5.83301 8.06055 5.83301 8.75C5.83301 9.43945 6.28223 10 6.83301 10ZM3.08301 9.5C2.66895 9.5 2.33301 9.16406 2.33301 8.75C2.33301 8.33594 2.66895 8 3.08301 8C3.49707 8 3.83301 8.33594 3.83301 8.75C3.83301 9.16406 3.49707 9.5 3.08301 9.5ZM10.583 9.5C10.1689 9.5 9.83301 9.16406 9.83301 8.75C9.83301 8.33594 10.1689 8 10.583 8C10.9971 8 11.333 8.33594 11.333 8.75C11.333 9.16406 10.9971 9.5 10.583 9.5ZM6.33301 4V2.5H4.33301L6.83301 0L9.33301 2.5H7.33301V4H6.33301Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </div>
                </div>
                <div class="flex items-center justify-end w-1/5 right_block">
                  <svg
                    width="18"
                    height="18"
                    class="h-4-5 w-4-5"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 0C4.03711 0 0 4.03711 0 9C0 13.9629 4.03711 18 9 18C13.9629 18 18 13.9629 18 9C18 4.03711 13.9629 0 9 0ZM9.86719 1.57031C13.6084 1.99805 16.5 5.1416 16.5 9C16.5 12.8584 13.6084 16.002 9.86719 16.4297C10.9746 15.2578 12.75 12.8057 12.75 9C12.75 5.19434 10.9746 2.74219 9.86719 1.57031Z"
                      fill="#676666"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <div class="filter-item_block">
            <p
              class="
                font-bold
                text-sm
                font-bold
                text-darkblack
                font-bold
                filter_title
                mb-2.5
              "
            >
              {{ $t("pages.filters.demented_patients.heading") }}
            </p>
            <div class="filter_list_block">
              <div
                class="flex justify-between items-center filtermenu_block"
                :class="{ 'opacity-50': !loggedIn }"
              >
                <div class="flex w-5/5 left_block">
                  <div class="iconbox">
                    <label class="custome_check">
                      <input
                        v-model="filters.dementia.no_to_mild"
                        type="checkbox"
                        :disabled="!loggedIn"
                      />
                      <span class="checkmark"></span>
                      <span class="font-medium">
                        {{
                          $t(
                            "pages.filters.demented_patients.no_to_mild_dementia"
                          )
                        }}
                      </span>
                    </label>
                  </div>
                </div>
              </div>

              <div
                class="flex justify-between items-center filtermenu_block"
                :class="{ 'opacity-50': !loggedIn }"
              >
                <div
                  class="flex w-5/5 left_block"
                  :class="{ 'opacity-50': !loggedIn }"
                >
                  <div class="iconbox">
                    <label class="custome_check">
                      <input
                        v-model="filters.dementia.advanced"
                        type="checkbox"
                        :disabled="!loggedIn"
                      />
                      <span class="checkmark"></span>
                      <span class="font-medium">
                        {{
                          $t(
                            "pages.filters.demented_patients.advanced_dementia"
                          )
                        }}
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="filter-item_block">
            <div class="form-block">
              <p
                class="
                  font-bold
                  text-xs
                  font-bold
                  text-darkblack
                  font-bold
                  filter_title
                  mb-2.5
                "
              >
                {{ $t("pages.filters.desired_minimum_net_salary") }}
              </p>
              <div class="flex border rounded border-solid input-group">
                <select
                  v-model.number="filters.desired_min_salary"
                  class="placeholder-gray-500 form-control text-sm w-full"
                  :disabled="!loggedIn"
                >
                  <option value="null">
                    {{
                      $t(
                        "pages.filters.most_favorable_place_of_action.placeholder"
                      )
                    }}
                  </option>
                  <option
                    v-for="(salary, salaryIdx) in dropDown.salaries"
                    :key="salaryIdx"
                    :value="salaryIdx"
                  >
                    {{ salary | formatCurrencyEuro }}
                  </option>
                </select>
              </div>
            </div>

            <div class="form-block">
              <p
                class="
                  font-bold
                  text-xs
                  font-bold
                  text-darkblack
                  font-bold
                  filter_title
                  mb-2.5
                "
              >
                {{ $t("pages.filters.most_favorable_place_of_action.heading") }}
              </p>
              <div class="flex border rounded border-solid input-group">
                <select
                  v-model.number="filters.favorable_place"
                  class="placeholder-gray-500 form-control w-full"
                  :disabled="!loggedIn"
                >
                  <optgroup
                    v-for="(location, locIdx) in dropDown.locations"
                    :key="locIdx"
                    :label="location.name"
                  >
                  <option value=""></option>
                    <option
                      v-for="(locOpt, locOptIdx) in location.options"
                      :key="locOptIdx"
                      :value="locOptIdx"
                    >
                      {{ locOpt }}
                    </option>
                  </optgroup>
                </select>
              </div>
            </div>
          </div>

          <div class="filter-item_block">
            <p
              class="
                font-bold
                text-sm
                font-bold
                text-darkblack
                font-bold
                filter_title
                mb-2.5
              "
            >
              {{ $t("pages.filters.residential_area.heading") }}
            </p>
            <div class="filter_list_block">
              <div
                class="flex justify-between items-center filtermenu_block"
                :class="{ 'opacity-50': !loggedIn }"
              >
                <div class="w-4/5 left_block">
                  <div class="iconbox">
                    <label class="custome_check">
                      <input
                        v-model="filters.residential_area.urban"
                        type="checkbox"
                        :disabled="!loggedIn"
                      />
                      <span class="checkmark"></span>
                      <span class="font-medium">
                        {{ $t("pages.filters.residential_area.urban") }}
                      </span>
                    </label>
                  </div>
                </div>
                <div class="flex items-center justify-end w-1/5 right_block">
                  <svg
                    width="20"
                    height="19"
                    class="h-4-5 w-4-5"
                    viewBox="0 0 20 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.5 0.912109L0.25 3.53711V19H10.75H19.75V5.5H10.75V3.53711L5.5 0.912109ZM5.5 2.58789L9.25 4.46289V17.5H1.75V4.46289L5.5 2.58789ZM3.25 5.5V7H4.75V5.5H3.25ZM6.25 5.5V7H7.75V5.5H6.25ZM10.75 7H18.25V17.5H10.75V7ZM3.25 8.5V10H4.75V8.5H3.25ZM6.25 8.5V10H7.75V8.5H6.25ZM12.25 8.5V10H13.75V8.5H12.25ZM15.25 8.5V10H16.75V8.5H15.25ZM3.25 11.5V13H4.75V11.5H3.25ZM6.25 11.5V13H7.75V11.5H6.25ZM12.25 11.5V13H13.75V11.5H12.25ZM15.25 11.5V13H16.75V11.5H15.25ZM3.25 14.5V16H4.75V14.5H3.25ZM6.25 14.5V16H7.75V14.5H6.25ZM12.25 14.5V16H13.75V14.5H12.25ZM15.25 14.5V16H16.75V14.5H15.25Z"
                      fill="#676666"
                    />
                  </svg>
                </div>
              </div>

              <div
                class="flex justify-between items-center filtermenu_block"
                :class="{ 'opacity-50': !loggedIn }"
              >
                <div class="w-4/5 left_block">
                  <div class="iconbox">
                    <label class="custome_check">
                      <input
                        v-model="filters.residential_area.rural"
                        type="checkbox"
                        :disabled="!loggedIn"
                      />
                      <span class="checkmark"></span>
                      <span class="font-medium">
                        {{ $t("pages.filters.residential_area.rural") }}
                      </span>
                    </label>
                  </div>
                </div>
                <div class="flex items-center justify-end w-1/5 right_block">
                  <svg
                    width="18"
                    height="18"
                    class="h-4-5 w-4-5"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 0.662109L8.48584 2.41846L6.75 5.02295V8.25H3.75V7.18799C4.58002 6.85544 5.25 6.19247 5.25 5.25C5.25 4.63314 5.06837 3.73624 4.77393 2.83154C4.6267 2.3792 4.45491 1.94684 4.22021 1.57178C3.98552 1.19671 3.6478 0.75 3 0.75C2.3522 0.75 2.01448 1.19671 1.77979 1.57178C1.54509 1.94684 1.3733 2.3792 1.22607 2.83154C0.931629 3.73624 0.75 4.63314 0.75 5.25C0.75 6.19247 1.41998 6.85544 2.25 7.18799V8.25H0.75V9.75H3.61816C2.44061 11.025 0.75 13.2603 0.75 17.25H2.25C2.25 12.5579 5.31489 9.96706 5.57666 9.75H7.36816C6.19061 11.025 4.5 13.2603 4.5 17.25H6C6 12.5579 9.06489 9.96706 9.32666 9.75H11.1182C9.94061 11.025 8.25 13.2603 8.25 17.25H9.75C9.75 12.5579 12.8149 9.96706 13.0767 9.75H14.7583C13.6301 11.0544 12 13.553 12 17.25H13.5C13.5 12.3571 16.9688 9.58594 16.9688 9.58594L17.25 9.36035V5.02295L15.5142 2.41846L12 0.662109ZM12 2.33789L14.4858 3.58154L15.75 5.47705V8.25H14.25V5.25H9.75V8.25H8.25V5.47705L9.51416 3.58154L12 2.33789ZM3 2.4873C3.11343 2.69235 3.23903 2.96365 3.34717 3.2959C3.59554 4.05902 3.75 5.03811 3.75 5.25C3.75 5.67377 3.42377 6 3 6C2.57623 6 2.25 5.67377 2.25 5.25C2.25 5.03811 2.40446 4.05902 2.65283 3.2959C2.76097 2.96365 2.88657 2.69235 3 2.4873ZM11.25 6.75H12.75V8.25H11.25V6.75Z"
                      fill="#676666"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <div class="filter-item_block">
            <p
              class="
                font-bold
                text-sm
                font-bold
                text-darkblack
                filter_title
                mb-2.5
              "
            >
              {{ $t("pages.filters.car_trips.heading") }}
            </p>
            <div class="filter_list_block">
              <div
                class="flex justify-between items-center filtermenu_block"
                :class="{ 'opacity-50': !loggedIn }"
              >
                <div class="w-4/5 left_block">
                  <div class="iconbox">
                    <label class="custome_check">
                      <input
                        v-model="filters.car_trips.no"
                        type="checkbox"
                        :disabled="!loggedIn"
                      />
                      <span class="checkmark"></span>
                      <span class="font-medium">
                        {{ $t("pages.filters.car_trips.no_need_to_drive") }}
                      </span>
                    </label>
                  </div>
                </div>
                <div class="flex items-center justify-end w-1/5 right_block">
                  <svg
                    width="11"
                    height="18"
                    class="h-4-5 w-4-5"
                    viewBox="0 0 11 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.375 0C4.93359 0 3.75 1.18359 3.75 2.625C3.75 4.06641 4.93359 5.25 6.375 5.25C7.81641 5.25 9 4.06641 9 2.625C9 1.18359 7.81641 0 6.375 0ZM6.375 1.5C7.00488 1.5 7.5 1.99512 7.5 2.625C7.5 3.25488 7.00488 3.75 6.375 3.75C5.74512 3.75 5.25 3.25488 5.25 2.625C5.25 1.99512 5.74512 1.5 6.375 1.5ZM3.60938 5.4375C3.22266 5.46973 2.8623 5.6543 2.60156 5.95312L1.24219 7.52344C1.06348 7.72852 0.9375 7.98047 0.890625 8.25L0.375 11.1562L1.85156 11.4141L2.36719 8.50781L3.72656 6.9375H3.75L4.33594 7.05469L3.44531 11.0859C3.35449 11.5049 3.45117 11.9355 3.70312 12.2812L7.85156 18H9.70312L4.92188 11.3906L5.8125 7.33594L6.16406 7.40625L6.72656 9.375C6.8584 9.82617 7.19824 10.1924 7.64062 10.3594L10.2891 11.3672L10.8047 9.96094L8.17969 8.95312L7.59375 6.98438C7.43848 6.44238 6.99902 6.03516 6.44531 5.92969L4.00781 5.46094C3.87891 5.4375 3.73828 5.42578 3.60938 5.4375ZM3.35156 13.5234L2.97656 14.9766L0.796875 18H2.64844L4.38281 15.6328L4.47656 15.1875L3.35156 13.5234Z"
                      fill="#676666"
                    />
                  </svg>
                </div>
              </div>

              <div
                class="flex justify-between items-center filtermenu_block"
                :class="{ 'opacity-50': !loggedIn }"
              >
                <div class="w-4/5 left_block">
                  <div class="iconbox">
                    <label class="custome_check">
                      <input
                        v-model="filters.car_trips.yes"
                        type="checkbox"
                        :disabled="!loggedIn"
                      />
                      <span class="checkmark"></span>
                      <span class="font-medium">
                        {{
                          $t("pages.filters.car_trips.driving_required.text")
                        }}
                      </span>
                    </label>
                  </div>
                  <div class="iconbox" @click="showNotification">
                    <svg
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.333008 12.5V5H13.333V12.5H0.333008ZM2.33301 11.5H11.333C11.333 10.9473 11.7803 10.5 12.333 10.5V7C11.7803 7 11.333 6.55273 11.333 6H2.33301C2.33301 6.55273 1.88574 7 1.33301 7V10.5C1.88574 10.5 2.33301 10.9473 2.33301 11.5ZM6.83301 11C5.72754 11 4.83301 9.99219 4.83301 8.75C4.83301 7.50781 5.72754 6.5 6.83301 6.5C7.93848 6.5 8.83301 7.50781 8.83301 8.75C8.83301 9.99219 7.93848 11 6.83301 11ZM6.83301 10C7.38379 10 7.83301 9.43945 7.83301 8.75C7.83301 8.06055 7.38379 7.5 6.83301 7.5C6.28223 7.5 5.83301 8.06055 5.83301 8.75C5.83301 9.43945 6.28223 10 6.83301 10ZM3.08301 9.5C2.66895 9.5 2.33301 9.16406 2.33301 8.75C2.33301 8.33594 2.66895 8 3.08301 8C3.49707 8 3.83301 8.33594 3.83301 8.75C3.83301 9.16406 3.49707 9.5 3.08301 9.5ZM10.583 9.5C10.1689 9.5 9.83301 9.16406 9.83301 8.75C9.83301 8.33594 10.1689 8 10.583 8C10.9971 8 11.333 8.33594 11.333 8.75C11.333 9.16406 10.9971 9.5 10.583 9.5ZM6.33301 4V2.5H4.33301L6.83301 0L9.33301 2.5H7.33301V4H6.33301Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </div>
                </div>
                <div class="flex items-center justify-end w-1/5 right_block">
                  <svg
                    width="20"
                    height="16"
                    class="h-4-5 w-4-5"
                    viewBox="0 0 20 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.125 0.5C4.13477 0.5 3.25293 1.14453 2.96875 2.09375L1.9375 5.53906L0.484375 5.04688L0.015625 6.45312L1.49219 6.94531L1.02344 8.53906C1.00586 8.60645 0.99707 8.67969 1 8.75V14C1 14.0234 1 14.0469 1 14.0703V14.75C1 15.1631 1.33691 15.5 1.75 15.5H4L4.25781 14.75H15.7422L16 15.5H18.25C18.6631 15.5 19 15.1631 19 14.75V14.1172C19.0029 14.0791 19.0029 14.0381 19 14V8.75C19.0029 8.67969 18.9941 8.60645 18.9766 8.53906L18.5078 6.94531L19.9844 6.45312L19.5156 5.04688L18.0625 5.53906L17.0312 2.09375C16.7471 1.14453 15.8652 0.5 14.875 0.5H5.125ZM5.125 2H14.875C15.209 2 15.5049 2.21973 15.6016 2.53906L16.5625 5.75H3.4375L4.39844 2.53906C4.49512 2.2168 4.79102 2 5.125 2ZM2.99219 7.25H17.0078L17.5 8.89062V13.25H2.5V8.89062L2.99219 7.25ZM4.375 8C3.75391 8 3.25 8.50391 3.25 9.125C3.25 9.74609 3.75391 10.25 4.375 10.25C4.99609 10.25 5.5 9.74609 5.5 9.125C5.5 8.50391 4.99609 8 4.375 8ZM15.625 8C15.0039 8 14.5 8.50391 14.5 9.125C14.5 9.74609 15.0039 10.25 15.625 10.25C16.2461 10.25 16.75 9.74609 16.75 9.125C16.75 8.50391 16.2461 8 15.625 8ZM7 10.25L6.0625 12.5H7.67969L8.00781 11.75H11.9922L12.3203 12.5H13.9375L13 10.25H7Z"
                      fill="#676666"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <div class="filter-item_block filter-item_end">
            <p
              class="
                font-bold
                text-sm
                font-bold
                text-darkblack
                filter_title
                mb-2.5
              "
            >
              {{ $t("pages.filters.accommodation.heading") }}
            </p>
            <div class="filter_list_block">
              <div
                class="flex justify-between items-center filtermenu_block"
                :class="{ 'opacity-50': !loggedIn }"
              >
                <div class="w-4/5 left_block">
                  <div class="iconbox">
                    <label class="custome_check">
                      <input
                        v-model="filters.accommodation.house"
                        type="checkbox"
                        :disabled="!loggedIn"
                      />
                      <span class="checkmark"></span>
                      <span class="font-medium">
                        {{ $t("pages.filters.accommodation.haus") }}
                      </span>
                    </label>
                  </div>
                </div>
                <div class="flex items-center justify-end w-1/5 right_block">
                  <svg
                    width="18"
                    height="20"
                    class="h-4-5 w-4-5"
                    viewBox="0 0 18 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.97559 0.000362923C8.81566 0.00582418 8.66168 0.0622851 8.53613 0.161496L1.42969 5.76013C0.527739 6.47094 0 7.55712 0 8.70544V18.2504C0 18.9322 0.568203 19.5004 1.25 19.5004H6.25C6.9318 19.5004 7.5 18.9322 7.5 18.2504V13.2504C7.5 13.1028 7.60248 13.0004 7.75 13.0004H10.25C10.3975 13.0004 10.5 13.1028 10.5 13.2504V18.2504C10.5 18.9322 11.0682 19.5004 11.75 19.5004H16.75C17.4318 19.5004 18 18.9322 18 18.2504V8.70544C18 7.55712 17.4723 6.47094 16.5703 5.76013L9.46387 0.161496C9.32518 0.0519334 9.15225 -0.00513271 8.97559 0.000362923ZM9 1.70544L15.6426 6.93884C16.1846 7.36602 16.5 8.01577 16.5 8.70544V18.0004H12V13.2504C12 12.2929 11.2075 11.5004 10.25 11.5004H7.75C6.79252 11.5004 6 12.2929 6 13.2504V18.0004H1.5V8.70544C1.5 8.01577 1.81537 7.36602 2.35742 6.93884L9 1.70544Z"
                      fill="#676666"
                    />
                  </svg>
                </div>
              </div>

              <div
                class="flex justify-between items-center filtermenu_block"
                :class="{ 'opacity-50': !loggedIn }"
              >
                <div class="w-4/5 left_block">
                  <div class="iconbox">
                    <label class="custome_check">
                      <input
                        v-model="filters.accommodation.apartment"
                        type="checkbox"
                        :disabled="!loggedIn"
                      />
                      <span class="checkmark"></span>
                      <span class="font-medium">
                        {{ $t("pages.filters.accommodation.flat") }}
                      </span>
                    </label>
                  </div>
                </div>
                <div class="flex items-center justify-end w-1/5 right_block">
                  <svg
                    width="20"
                    height="19"
                    class="h-4-5 w-4-5"
                    viewBox="0 0 20 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.5 0.912109L0.25 3.53711V19H10.75H19.75V5.5H10.75V3.53711L5.5 0.912109ZM5.5 2.58789L9.25 4.46289V17.5H1.75V4.46289L5.5 2.58789ZM3.25 5.5V7H4.75V5.5H3.25ZM6.25 5.5V7H7.75V5.5H6.25ZM10.75 7H18.25V17.5H10.75V7ZM3.25 8.5V10H4.75V8.5H3.25ZM6.25 8.5V10H7.75V8.5H6.25ZM12.25 8.5V10H13.75V8.5H12.25ZM15.25 8.5V10H16.75V8.5H15.25ZM3.25 11.5V13H4.75V11.5H3.25ZM6.25 11.5V13H7.75V11.5H6.25ZM12.25 11.5V13H13.75V11.5H12.25ZM15.25 11.5V13H16.75V11.5H15.25ZM3.25 14.5V16H4.75V14.5H3.25ZM6.25 14.5V16H7.75V14.5H6.25ZM12.25 14.5V16H13.75V14.5H12.25ZM15.25 14.5V16H16.75V14.5H15.25Z"
                      fill="#676666"
                    />
                  </svg>
                </div>
              </div>

              <div
                class="flex justify-between items-center filtermenu_block"
                :class="{ 'opacity-50': !loggedIn }"
              >
                <div class="w-4/5 left_block">
                  <div class="iconbox">
                    <label for=""></label>
                    <label class="custome_check">
                      <input
                        v-model="filters.accommodation.own_room"
                        type="checkbox"
                        :disabled="!loggedIn"
                      />
                      <span class="checkmark"></span>
                      <span class="font-medium">
                        {{ $t("pages.filters.accommodation.own_room") }}
                      </span>
                    </label>
                  </div>
                </div>
                <div class="flex items-center justify-end w-1/5 right_block">
                  <svg
                    width="18"
                    height="18"
                    class="h-4-5 w-4-5"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.8125 0L8.69531 0.0234375L0.539062 2.55469L0 2.71875V14.7656L0.492188 14.9297L8.64844 17.9531L8.78906 18H9.21094L9.35156 17.9531L17.5078 14.9297L18 14.7656V2.71875L17.4609 2.55469L9.30469 0.0234375L9.1875 0H8.8125ZM8.25 1.75781V10.875L1.5 13.1953V3.84375L8.25 1.75781ZM9.75 1.75781L16.5 3.84375V13.1953L14.25 12.4219V5.67188L11.25 4.71094V11.3906L9.75 10.875V1.75781ZM6.75 4.80469L3.75 5.74219V9.86719L6.75 8.69531V4.80469ZM9 12.1875L15 14.25L9 16.4766L3 14.25L9 12.1875Z"
                      fill="#676666"
                    />
                  </svg>
                </div>
              </div>

              <div
                class="flex justify-between items-center filtermenu_block"
                :class="{ 'opacity-50': !loggedIn }"
              >
                <div class="w-4/5 left_block">
                  <div class="iconbox">
                    <label class="custome_check">
                      <input
                        v-model="filters.accommodation.own_toilet"
                        type="checkbox"
                        :disabled="!loggedIn"
                      />
                      <span class="checkmark"></span>
                      <span class="font-medium">
                        {{ $t("pages.filters.accommodation.own_toilet") }}
                      </span>
                    </label>
                  </div>
                </div>
                <div class="flex items-center justify-end w-1/5 right_block">
                  <svg
                    width="18"
                    height="18"
                    class="h-4-5 w-4-5"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.5 0C1.10742 0 0.706055 0.137695 0.421875 0.421875C0.137695 0.706055 0 1.10742 0 1.5V9.75C0 11.8418 1.23926 13.5879 3 14.6953V18H14.25V14.6953C16.0107 13.5879 17.25 11.8418 17.25 9.75V9H7.5V1.5C7.5 1.10742 7.3623 0.706055 7.07812 0.421875C6.79395 0.137695 6.39258 0 6 0H1.5ZM1.5 1.5H6V9H1.5V1.5ZM3 3V5.25H4.5V3H3ZM1.73438 10.5H15.5156C15.249 11.7949 14.4902 12.9375 13.1484 13.6641L12.75 13.875V16.5H4.5V13.875L4.10156 13.6641C2.75977 12.9375 2.00098 11.7949 1.73438 10.5Z"
                      fill="#676666"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <div
            class="
              w-full
              flex
              items-center
              justify-center
              p-4
              absolute
              left-0
              bottom-0
              bg-white
            "
          >
            <button
              class="
                w-full
                flex
                items-center
                justify-center
                btn_apply
                rounded-lg
                text-white
                btn_action
              "
              @click="closeModal(true)"
            >
              <svg
                width="18"
                height="18"
                class="h-4-5 w-4-5 mr-2-8"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.25 0C0.568203 0 0 0.568203 0 1.25V2.79492C0 3.94325 0.527739 5.02942 1.42969 5.74023L6.5 9.73535V17.25C6.50007 17.3877 6.53806 17.5228 6.60981 17.6404C6.68155 17.7579 6.78429 17.8535 6.90674 17.9165C7.0292 17.9796 7.16665 18.0077 7.30403 17.9978C7.44141 17.9879 7.5734 17.9403 7.68555 17.8604L11.1855 15.3604C11.2828 15.291 11.362 15.1994 11.4167 15.0933C11.4714 14.9871 11.5 14.8694 11.5 14.75V9.73438L16.5703 5.74023C17.4723 5.02942 18 3.94325 18 2.79492V1.25C18 0.568203 17.4318 0 16.75 0H1.25ZM1.5 1.5H16.5V2.79492C16.5 3.4846 16.1846 4.13434 15.6426 4.56152L10.6436 8.5H7.35645L2.35742 4.56152C1.81537 4.13434 1.5 3.4846 1.5 2.79492V1.5ZM8 10H10V14.3643L8 15.793V10Z"
                  fill="white"
                />
              </svg>
              {{ $t("pages.filters.buttons.showing_result") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <notification />
  </div>
</template>

<script>
import Notification from "@/components/modals/Notification";
import { mapGetters } from "vuex";

export default {
  name: "FavoriteFilters",
  components: { Notification },
  props: {
    showFilters: {
      default: false,
      type: Boolean,
    },
    reset: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      favorite: false,
      isInfoModal: false,
      filters: this.$store.getters["offer/filters"],
    };
  },
  computed: {
    ...mapGetters("offer", ["dropDown"]),
    isFilterOpened() {
      return this.showFilters;
    },
  },
  watch: {
    showFilters(newVal) {
      if (newVal) {
        this.filters = this.$store.getters["offer/filters"];
      }
    },
    reset(newVal) {
      if (newVal) {
        this.filters = this.defaultFilters();
      }
    },
  },
  created() {
    this.$store.dispatch("offer/fetchFilters");
  },
  methods: {
    closeModal(update = false) {
      this.$emit("update:show-filters", false);
      this.isInfoModal = false;
      if (update === true) {
        if (this.loggedIn) {
          this.$store.commit("offer/setFilters", this.filters);
          this.$store.dispatch("offer/saveFavoriteFilter");
        } else {
          this.$router.push({ name: "confirmCell" });
        }
      }
    },
    async defaultFilters() {
      await this.$store.dispatch("offer/resetFilters");
      this.filters = this.$store.getters["offer/filters"];
      // return this.$store.getters["offer/filters"];
    },
    showNotification(data) {
      this.$store.commit("app/showNotification", data);
    },
    InfoModal() {
      this.isInfoModal = !this.isInfoModal;
    },
  },
};
</script>

<style scoped>
.info-model {
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.16), 0px 0px 1px rgba(0, 0, 0, 0.04);
  border-radius: 10px;
}

.btn_apply {
  background-color: #63b15b !important;
  color: #fff !important;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  padding: 7px 12px;
  letter-spacing: 0.5px;
  border: 1px solid #63b15b !important;
  outline: none !important;
  box-shadow: none !important;
}

.filter_model_block {
  z-index: 99999999999999999999;
}

.filter_model_block .modal-container {
  max-height: 100%;
  overflow: auto;
}

.filter_model_block .Header_block {
  width: 100%;
  margin: 0 0 30px;
  padding: 0;
}

.filter_model_block .Header_block .cancel_block {
  display: block;
}

.filter_model_block .Header_block .cancel_block svg {
  /* width: 20px;
  height: 20px; */
  fill: #676666;
}

.filter_model_block .Header_block .cancel_block svg path {
  fill: #676666;
}

.filter_model_block .Header_block .title_block {
  text-transform: capitalize;
  text-align: center;
}

.filter_model_block .Header_block .wish_block {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.filter_model_block .Header_block .wish_block .refresh_block {
  margin-left: 30px;
}

.filter_model_block .filter-item_block {
  display: block;
  border-bottom: 1px solid #e2e2e2;
  padding: 0 0 15px;
  margin: 0 0 20px;
}

/* .filter_model_block .filter-item_block .filter_title {
  font-size: 18px;
  margin: 0 0 15px;
} */

.filter_model_block .filter-item_block .filoption-block {
  width: 100%;
  margin: 0 0 15px;
  border: 1px solid #c6c6d1;
  border-radius: 4px;
}

.filter_model_block .filter-item_block .filoption-block .btn_action {
  text-align: center;
  font-weight: 700;
  text-transform: capitalize;
  color: #676666;
  padding: 10px 10px;
}

.filter_model_block .filter-item_block .filoption-block .btn_action svg {
  margin-left: 10px;
}

.filter_model_block .filter-item_block .filoption-block .btn_action.active {
  background: #63b15b;
  color: white;
}

.filter_model_block .filter-item_block .filter_list_block {
  display: block;
}

.filter_model_block .filter-item_block .filter_list_block .filtermenu_block {
  width: 100%;
  margin: 0 0 15px;
}

.filter_model_block
  .filter-item_block
  .filter_list_block
  .filtermenu_block
  .left_block {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.filter_model_block
  .filter-item_block
  .filter_list_block
  .filtermenu_block
  .left_block
  .iconbox {
  /*width: 30px;*/
  /*height: 30px;*/
  width: auto;
  height: auto;
  min-hheight: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-right: 5px;
}

.filter_model_block
  .filter-item_block
  .filter_list_block
  .filtermenu_block
  .left_block
  .iconbox
  svg {
  width: auto;
  height: auto;
}

.filter_model_block
  .filter-item_block
  .filter_list_block
  .filtermenu_block
  .left_block
  .iconbox
  svg
  path {
}

.filter_model_block
  .filter-item_block
  .filter_list_block
  .filtermenu_block
  .left_block
  p.text-2xl.font-normal {
}

.filter_model_block
  .filter-item_block
  .filter_list_block
  .filtermenu_block
  .left_block
  p {
  font-size: 13px;
  color: #676666;
  font-weight: 500;
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.custome_radio {
  display: block;
  position: relative;
  cursor: pointer;
  margin: 0;
  padding: 0;
  width: auto;
  height: auto;
  padding-left: 30px;
}
.custome_radio input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
.custome_radio .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 26px;
  width: 26px;
  border-radius: 100%;
  border: 2px solid #c6c6d1;
}
.custome_radio:hover input ~ .checkmark {
  background-color: transparent;
}
.custome_radio input:checked ~ .checkmark {
  background-color: transparent;
  border-color: #63b15b;
}
.custome_radio .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.custome_radio input:checked ~ .checkmark:after {
  display: block;
}
.custome_radio .checkmark:after {
  top: 15%;
  left: 15%;
  width: 70%;
  height: 70%;
  border-radius: 100%;
  background: #63b15b;
}

.custome_check {
  display: block;
  position: relative;
  cursor: pointer;
  margin: 0;
  padding: 0;
  width: auto;
  height: auto;
  padding-left: 30px;
}
.custome_check input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.custome_check .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 26px;
  width: 26px;
  border: 2px solid #c6c6d1;
  border-radius: 4px;
  background: transparent;
}
.custome_check:hover input ~ .checkmark {
  background-color: transparent;
}
.custome_check input:checked ~ .checkmark {
  background-color: #63b15b;
  border-color: #63b15b;
}

.custome_check .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.custome_check input:checked ~ .checkmark:after {
  display: block;
}
.custome_check .checkmark:after {
  left: 36%;
  top: 15%;
  width: 30%;
  height: 60%;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.filter_model_block
  .filter-item_block
  .filter_list_block
  .filtermenu_block
  .right_block {
}

.filter_model_block .filter-item_block .form-block {
  width: 100%;
  margin: 0 0 15px;
}

.filter_model_block .filter-item_block .form-block .input-group {
  width: 100%;
}

.filter_model_block .filter-item_block .form-block .input-group .form-control {
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 16px;
  color: gray;
}
.filter_model_block
  .filter-item_block
  .form-block
  .input-group
  .form-control
  option {
  color: black;
}

.filter_model_block
  .filter-item_block
  .filter_list_block
  .filtermenu_block
  .left_block
  p
  svg {
  margin-left: 20px;
}

.filter_model_block .filter-item_block.filter-item_end {
  border-bottom: 0 solid #e2e2e2;
}

.filter_model_block .modal-container {
  max-height: 85%;
  overflow: auto;
}

.filter_model_block .modal-container .modal-content {
  padding-bottom: 40px;
  padding-left: 1rem;
  padding-right: 1rem;
}
.pkss-text.secondary {
  color: #676666;
  font-size: 14px;
}

.filter_model_block
  .filter-item_block
  .form-block
  .input-group
  .form-control[data-v-4cdf117c] {
  width: 100%;
  border-radius: 0;
  background: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  box-shadow: none !important;
}

/*----------------------------- Model Css ------------------------------------*/
/*----------------------------- Model Css ------------------------------------*/

.filter_model_block .Header_block .wish_block .refresh_block {
  margin-left: 13px;
}
.filter_model_block .filter-item_block .filoption-block .btn_action {
  padding: 10px 7px;
  font-size: 14px;
}

.filter_model_block .filter-item_block .filoption-block .btn_action svg {
  margin-left: 7px;
}

.filter_model_block
  .filter-item_block
  .filter_list_block
  .filtermenu_block
  .left_block
  p {
  font-size: 13px;
  margin-right: 7px;
}

.filter_model_block
  .filter-item_block
  .filter_list_block
  .filtermenu_block
  .left_block
  .iconbox {
  width: auto;
  height: auto;
  min-height: 29px;
}

.custome_radio .checkmark {
  width: 20px;
  height: 20px;
}

.filter_model_block .filter-item_block .filter_list_block .filtermenu_block {
  margin: 0 0 12px;
}

.custome_check .checkmark {
  width: 20px;
  height: 20px;
}

.filter_model_block .filter-item_block {
  padding: 0 0 10px;
  margin: 0 0 16px;
}

.custome_check {
  height: auto;
  width: auto;
}

/*----------------------------- Model Css ------------------------------------*/
</style>
